/**
 * App shell. We open into the chart-first interface from the UI design plan: a
 * calm resting screen with the chart, the simulated boat, four controls and one
 * data field, and everything else summoned into sheets.
 *
 * The older floating-panel layout still lives in src/ui/ and drives the same
 * stores; the new shell surfaces that same milestone work (M1 to M5) through the
 * agreed interface. SimRunner is mounted inside the shell.
 */
import { Shell } from './ui/shell/Shell';

export function App() {
  return <Shell />;
}
